/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceRouteImport } from './routes/_workspace'
import { Route as NotAuthorizedRouteImport } from './routes/not-authorized'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as WorkspaceIndexRouteImport } from './routes/_workspace/index'
import { Route as WorkspaceMeRouteImport } from './routes/_workspace/me'
import { Route as WorkspaceSettingsRouteImport } from './routes/_workspace/settings'
import { Route as EmbedSplatRouteImport } from './routes/embed.$'
import { Route as WorkspaceAppSplatRouteImport } from './routes/_workspace/app/$'
import { Route as WorkspaceChatsChatIdRouteImport } from './routes/_workspace/chats/$chatId'
import { Route as WorkspaceFilesSplatRouteImport } from './routes/_workspace/files/$'
import { Route as WorkspaceHistorySplatRouteImport } from './routes/_workspace/history/$'
import { Route as WorkspaceSettingsIndexRouteImport } from './routes/_workspace/settings/index'
import { Route as WorkspaceSettingsMcpRouteImport } from './routes/_workspace/settings/mcp'
import { Route as WorkspaceSettingsMembersRouteImport } from './routes/_workspace/settings/members'
import { Route as WorkspaceSettingsModelRouteImport } from './routes/_workspace/settings/model'
import { Route as WorkspaceSettingsNotificationsRouteImport } from './routes/_workspace/settings/notifications'
import { Route as WorkspaceSettingsPaymentsRouteImport } from './routes/_workspace/settings/payments'
import { Route as WorkspaceSettingsTimezoneRouteImport } from './routes/_workspace/settings/timezone'
import { Route as WorkspaceSettingsBillingIndexRouteImport } from './routes/_workspace/settings/billing/index'
import { Route as WorkspaceSettingsIntegrationsIndexRouteImport } from './routes/_workspace/settings/integrations/index'
import { Route as WorkspaceSettingsPolicyIndexRouteImport } from './routes/_workspace/settings/policy/index'
import { Route as WorkspaceSettingsPolicyActivityRouteImport } from './routes/_workspace/settings/policy/activity'
import { Route as WorkspaceSettingsSchedulesIndexRouteImport } from './routes/_workspace/settings/schedules/index'
import { Route as WorkspaceSettingsSchedulesExecutedRouteImport } from './routes/_workspace/settings/schedules/executed'

const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const NotAuthorizedRoute = NotAuthorizedRouteImport.update({
  id: '/not-authorized',
  path: '/not-authorized',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceMeRoute = WorkspaceMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSettingsRoute = WorkspaceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WorkspaceRoute,
} as any)
const EmbedSplatRoute = EmbedSplatRouteImport.update({
  id: '/embed/$',
  path: '/embed/$',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceAppSplatRoute = WorkspaceAppSplatRouteImport.update({
  id: '/app/$',
  path: '/app/$',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceChatsChatIdRoute = WorkspaceChatsChatIdRouteImport.update({
  id: '/chats/$chatId',
  path: '/chats/$chatId',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceFilesSplatRoute = WorkspaceFilesSplatRouteImport.update({
  id: '/files/$',
  path: '/files/$',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceHistorySplatRoute = WorkspaceHistorySplatRouteImport.update({
  id: '/history/$',
  path: '/history/$',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSettingsIndexRoute = WorkspaceSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const WorkspaceSettingsMcpRoute = WorkspaceSettingsMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const WorkspaceSettingsMembersRoute =
  WorkspaceSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsModelRoute = WorkspaceSettingsModelRouteImport.update({
  id: '/model',
  path: '/model',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const WorkspaceSettingsNotificationsRoute =
  WorkspaceSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsPaymentsRoute =
  WorkspaceSettingsPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsTimezoneRoute =
  WorkspaceSettingsTimezoneRouteImport.update({
    id: '/timezone',
    path: '/timezone',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsBillingIndexRoute =
  WorkspaceSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsIntegrationsIndexRoute =
  WorkspaceSettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsPolicyIndexRoute =
  WorkspaceSettingsPolicyIndexRouteImport.update({
    id: '/policy/',
    path: '/policy/',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsPolicyActivityRoute =
  WorkspaceSettingsPolicyActivityRouteImport.update({
    id: '/policy/activity',
    path: '/policy/activity',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsSchedulesIndexRoute =
  WorkspaceSettingsSchedulesIndexRouteImport.update({
    id: '/schedules/',
    path: '/schedules/',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsSchedulesExecutedRoute =
  WorkspaceSettingsSchedulesExecutedRouteImport.update({
    id: '/schedules/executed',
    path: '/schedules/executed',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof WorkspaceIndexRoute
  '/not-authorized': typeof NotAuthorizedRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/me': typeof WorkspaceMeRoute
  '/settings': typeof WorkspaceSettingsRouteWithChildren
  '/embed/$': typeof EmbedSplatRoute
  '/app/$': typeof WorkspaceAppSplatRoute
  '/chats/$chatId': typeof WorkspaceChatsChatIdRoute
  '/files/$': typeof WorkspaceFilesSplatRoute
  '/history/$': typeof WorkspaceHistorySplatRoute
  '/settings/mcp': typeof WorkspaceSettingsMcpRoute
  '/settings/members': typeof WorkspaceSettingsMembersRoute
  '/settings/model': typeof WorkspaceSettingsModelRoute
  '/settings/notifications': typeof WorkspaceSettingsNotificationsRoute
  '/settings/payments': typeof WorkspaceSettingsPaymentsRoute
  '/settings/timezone': typeof WorkspaceSettingsTimezoneRoute
  '/settings/': typeof WorkspaceSettingsIndexRoute
  '/settings/policy/activity': typeof WorkspaceSettingsPolicyActivityRoute
  '/settings/schedules/executed': typeof WorkspaceSettingsSchedulesExecutedRoute
  '/settings/billing/': typeof WorkspaceSettingsBillingIndexRoute
  '/settings/integrations/': typeof WorkspaceSettingsIntegrationsIndexRoute
  '/settings/policy/': typeof WorkspaceSettingsPolicyIndexRoute
  '/settings/schedules/': typeof WorkspaceSettingsSchedulesIndexRoute
}
export interface FileRoutesByTo {
  '/not-authorized': typeof NotAuthorizedRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/me': typeof WorkspaceMeRoute
  '/embed/$': typeof EmbedSplatRoute
  '/': typeof WorkspaceIndexRoute
  '/app/$': typeof WorkspaceAppSplatRoute
  '/chats/$chatId': typeof WorkspaceChatsChatIdRoute
  '/files/$': typeof WorkspaceFilesSplatRoute
  '/history/$': typeof WorkspaceHistorySplatRoute
  '/settings/mcp': typeof WorkspaceSettingsMcpRoute
  '/settings/members': typeof WorkspaceSettingsMembersRoute
  '/settings/model': typeof WorkspaceSettingsModelRoute
  '/settings/notifications': typeof WorkspaceSettingsNotificationsRoute
  '/settings/payments': typeof WorkspaceSettingsPaymentsRoute
  '/settings/timezone': typeof WorkspaceSettingsTimezoneRoute
  '/settings': typeof WorkspaceSettingsIndexRoute
  '/settings/policy/activity': typeof WorkspaceSettingsPolicyActivityRoute
  '/settings/schedules/executed': typeof WorkspaceSettingsSchedulesExecutedRoute
  '/settings/billing': typeof WorkspaceSettingsBillingIndexRoute
  '/settings/integrations': typeof WorkspaceSettingsIntegrationsIndexRoute
  '/settings/policy': typeof WorkspaceSettingsPolicyIndexRoute
  '/settings/schedules': typeof WorkspaceSettingsSchedulesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_workspace': typeof WorkspaceRouteWithChildren
  '/not-authorized': typeof NotAuthorizedRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/_workspace/me': typeof WorkspaceMeRoute
  '/_workspace/settings': typeof WorkspaceSettingsRouteWithChildren
  '/embed/$': typeof EmbedSplatRoute
  '/_workspace/': typeof WorkspaceIndexRoute
  '/_workspace/app/$': typeof WorkspaceAppSplatRoute
  '/_workspace/chats/$chatId': typeof WorkspaceChatsChatIdRoute
  '/_workspace/files/$': typeof WorkspaceFilesSplatRoute
  '/_workspace/history/$': typeof WorkspaceHistorySplatRoute
  '/_workspace/settings/mcp': typeof WorkspaceSettingsMcpRoute
  '/_workspace/settings/members': typeof WorkspaceSettingsMembersRoute
  '/_workspace/settings/model': typeof WorkspaceSettingsModelRoute
  '/_workspace/settings/notifications': typeof WorkspaceSettingsNotificationsRoute
  '/_workspace/settings/payments': typeof WorkspaceSettingsPaymentsRoute
  '/_workspace/settings/timezone': typeof WorkspaceSettingsTimezoneRoute
  '/_workspace/settings/': typeof WorkspaceSettingsIndexRoute
  '/_workspace/settings/policy/activity': typeof WorkspaceSettingsPolicyActivityRoute
  '/_workspace/settings/schedules/executed': typeof WorkspaceSettingsSchedulesExecutedRoute
  '/_workspace/settings/billing/': typeof WorkspaceSettingsBillingIndexRoute
  '/_workspace/settings/integrations/': typeof WorkspaceSettingsIntegrationsIndexRoute
  '/_workspace/settings/policy/': typeof WorkspaceSettingsPolicyIndexRoute
  '/_workspace/settings/schedules/': typeof WorkspaceSettingsSchedulesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/not-authorized'
    | '/onboarding'
    | '/sign-in'
    | '/me'
    | '/settings'
    | '/embed/$'
    | '/app/$'
    | '/chats/$chatId'
    | '/files/$'
    | '/history/$'
    | '/settings/mcp'
    | '/settings/members'
    | '/settings/model'
    | '/settings/notifications'
    | '/settings/payments'
    | '/settings/timezone'
    | '/settings/'
    | '/settings/policy/activity'
    | '/settings/schedules/executed'
    | '/settings/billing/'
    | '/settings/integrations/'
    | '/settings/policy/'
    | '/settings/schedules/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/not-authorized'
    | '/onboarding'
    | '/sign-in'
    | '/me'
    | '/embed/$'
    | '/'
    | '/app/$'
    | '/chats/$chatId'
    | '/files/$'
    | '/history/$'
    | '/settings/mcp'
    | '/settings/members'
    | '/settings/model'
    | '/settings/notifications'
    | '/settings/payments'
    | '/settings/timezone'
    | '/settings'
    | '/settings/policy/activity'
    | '/settings/schedules/executed'
    | '/settings/billing'
    | '/settings/integrations'
    | '/settings/policy'
    | '/settings/schedules'
  id:
    | '__root__'
    | '/_workspace'
    | '/not-authorized'
    | '/onboarding'
    | '/sign-in'
    | '/_workspace/me'
    | '/_workspace/settings'
    | '/embed/$'
    | '/_workspace/'
    | '/_workspace/app/$'
    | '/_workspace/chats/$chatId'
    | '/_workspace/files/$'
    | '/_workspace/history/$'
    | '/_workspace/settings/mcp'
    | '/_workspace/settings/members'
    | '/_workspace/settings/model'
    | '/_workspace/settings/notifications'
    | '/_workspace/settings/payments'
    | '/_workspace/settings/timezone'
    | '/_workspace/settings/'
    | '/_workspace/settings/policy/activity'
    | '/_workspace/settings/schedules/executed'
    | '/_workspace/settings/billing/'
    | '/_workspace/settings/integrations/'
    | '/_workspace/settings/policy/'
    | '/_workspace/settings/schedules/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
  NotAuthorizedRoute: typeof NotAuthorizedRoute
  OnboardingRoute: typeof OnboardingRoute
  SignInRoute: typeof SignInRoute
  EmbedSplatRoute: typeof EmbedSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_workspace': {
      id: '/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-authorized': {
      id: '/not-authorized'
      path: '/not-authorized'
      fullPath: '/not-authorized'
      preLoaderRoute: typeof NotAuthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace/': {
      id: '/_workspace/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/me': {
      id: '/_workspace/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof WorkspaceMeRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/settings': {
      id: '/_workspace/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof WorkspaceSettingsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/embed/$': {
      id: '/embed/$'
      path: '/embed/$'
      fullPath: '/embed/$'
      preLoaderRoute: typeof EmbedSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace/app/$': {
      id: '/_workspace/app/$'
      path: '/app/$'
      fullPath: '/app/$'
      preLoaderRoute: typeof WorkspaceAppSplatRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/chats/$chatId': {
      id: '/_workspace/chats/$chatId'
      path: '/chats/$chatId'
      fullPath: '/chats/$chatId'
      preLoaderRoute: typeof WorkspaceChatsChatIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/files/$': {
      id: '/_workspace/files/$'
      path: '/files/$'
      fullPath: '/files/$'
      preLoaderRoute: typeof WorkspaceFilesSplatRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/history/$': {
      id: '/_workspace/history/$'
      path: '/history/$'
      fullPath: '/history/$'
      preLoaderRoute: typeof WorkspaceHistorySplatRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/settings/': {
      id: '/_workspace/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof WorkspaceSettingsIndexRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/mcp': {
      id: '/_workspace/settings/mcp'
      path: '/mcp'
      fullPath: '/settings/mcp'
      preLoaderRoute: typeof WorkspaceSettingsMcpRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/members': {
      id: '/_workspace/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof WorkspaceSettingsMembersRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/model': {
      id: '/_workspace/settings/model'
      path: '/model'
      fullPath: '/settings/model'
      preLoaderRoute: typeof WorkspaceSettingsModelRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/notifications': {
      id: '/_workspace/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof WorkspaceSettingsNotificationsRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/payments': {
      id: '/_workspace/settings/payments'
      path: '/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof WorkspaceSettingsPaymentsRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/timezone': {
      id: '/_workspace/settings/timezone'
      path: '/timezone'
      fullPath: '/settings/timezone'
      preLoaderRoute: typeof WorkspaceSettingsTimezoneRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/billing/': {
      id: '/_workspace/settings/billing/'
      path: '/billing'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof WorkspaceSettingsBillingIndexRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/integrations/': {
      id: '/_workspace/settings/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof WorkspaceSettingsIntegrationsIndexRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/policy/': {
      id: '/_workspace/settings/policy/'
      path: '/policy'
      fullPath: '/settings/policy/'
      preLoaderRoute: typeof WorkspaceSettingsPolicyIndexRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/policy/activity': {
      id: '/_workspace/settings/policy/activity'
      path: '/policy/activity'
      fullPath: '/settings/policy/activity'
      preLoaderRoute: typeof WorkspaceSettingsPolicyActivityRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/schedules/': {
      id: '/_workspace/settings/schedules/'
      path: '/schedules'
      fullPath: '/settings/schedules/'
      preLoaderRoute: typeof WorkspaceSettingsSchedulesIndexRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/schedules/executed': {
      id: '/_workspace/settings/schedules/executed'
      path: '/schedules/executed'
      fullPath: '/settings/schedules/executed'
      preLoaderRoute: typeof WorkspaceSettingsSchedulesExecutedRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
  }
}

interface WorkspaceSettingsRouteChildren {
  WorkspaceSettingsMcpRoute: typeof WorkspaceSettingsMcpRoute
  WorkspaceSettingsMembersRoute: typeof WorkspaceSettingsMembersRoute
  WorkspaceSettingsModelRoute: typeof WorkspaceSettingsModelRoute
  WorkspaceSettingsNotificationsRoute: typeof WorkspaceSettingsNotificationsRoute
  WorkspaceSettingsPaymentsRoute: typeof WorkspaceSettingsPaymentsRoute
  WorkspaceSettingsTimezoneRoute: typeof WorkspaceSettingsTimezoneRoute
  WorkspaceSettingsIndexRoute: typeof WorkspaceSettingsIndexRoute
  WorkspaceSettingsPolicyActivityRoute: typeof WorkspaceSettingsPolicyActivityRoute
  WorkspaceSettingsSchedulesExecutedRoute: typeof WorkspaceSettingsSchedulesExecutedRoute
  WorkspaceSettingsBillingIndexRoute: typeof WorkspaceSettingsBillingIndexRoute
  WorkspaceSettingsIntegrationsIndexRoute: typeof WorkspaceSettingsIntegrationsIndexRoute
  WorkspaceSettingsPolicyIndexRoute: typeof WorkspaceSettingsPolicyIndexRoute
  WorkspaceSettingsSchedulesIndexRoute: typeof WorkspaceSettingsSchedulesIndexRoute
}

const WorkspaceSettingsRouteChildren: WorkspaceSettingsRouteChildren = {
  WorkspaceSettingsMcpRoute: WorkspaceSettingsMcpRoute,
  WorkspaceSettingsMembersRoute: WorkspaceSettingsMembersRoute,
  WorkspaceSettingsModelRoute: WorkspaceSettingsModelRoute,
  WorkspaceSettingsNotificationsRoute: WorkspaceSettingsNotificationsRoute,
  WorkspaceSettingsPaymentsRoute: WorkspaceSettingsPaymentsRoute,
  WorkspaceSettingsTimezoneRoute: WorkspaceSettingsTimezoneRoute,
  WorkspaceSettingsIndexRoute: WorkspaceSettingsIndexRoute,
  WorkspaceSettingsPolicyActivityRoute: WorkspaceSettingsPolicyActivityRoute,
  WorkspaceSettingsSchedulesExecutedRoute:
    WorkspaceSettingsSchedulesExecutedRoute,
  WorkspaceSettingsBillingIndexRoute: WorkspaceSettingsBillingIndexRoute,
  WorkspaceSettingsIntegrationsIndexRoute:
    WorkspaceSettingsIntegrationsIndexRoute,
  WorkspaceSettingsPolicyIndexRoute: WorkspaceSettingsPolicyIndexRoute,
  WorkspaceSettingsSchedulesIndexRoute: WorkspaceSettingsSchedulesIndexRoute,
}

const WorkspaceSettingsRouteWithChildren =
  WorkspaceSettingsRoute._addFileChildren(WorkspaceSettingsRouteChildren)

interface WorkspaceRouteChildren {
  WorkspaceMeRoute: typeof WorkspaceMeRoute
  WorkspaceSettingsRoute: typeof WorkspaceSettingsRouteWithChildren
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
  WorkspaceAppSplatRoute: typeof WorkspaceAppSplatRoute
  WorkspaceChatsChatIdRoute: typeof WorkspaceChatsChatIdRoute
  WorkspaceFilesSplatRoute: typeof WorkspaceFilesSplatRoute
  WorkspaceHistorySplatRoute: typeof WorkspaceHistorySplatRoute
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceMeRoute: WorkspaceMeRoute,
  WorkspaceSettingsRoute: WorkspaceSettingsRouteWithChildren,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
  WorkspaceAppSplatRoute: WorkspaceAppSplatRoute,
  WorkspaceChatsChatIdRoute: WorkspaceChatsChatIdRoute,
  WorkspaceFilesSplatRoute: WorkspaceFilesSplatRoute,
  WorkspaceHistorySplatRoute: WorkspaceHistorySplatRoute,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  WorkspaceRoute: WorkspaceRouteWithChildren,
  NotAuthorizedRoute: NotAuthorizedRoute,
  OnboardingRoute: OnboardingRoute,
  SignInRoute: SignInRoute,
  EmbedSplatRoute: EmbedSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
